import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import SalesInvoiceReportMiddleware from "../../../../middleware/modules/report/sales-report";
import { Helmet } from "react-helmet";
import FormSalesInvoiceCustomerReport from "../../../../components/modules/report/sales-report/sales-customer";

const mapStateToProps = ({ auth, salesInvoiceReport }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: salesInvoiceReport.isProcessing,
  isError: salesInvoiceReport.isError,
  errorMessage: salesInvoiceReport.errorMessage,
  datalist:salesInvoiceReport.dataCus,
  datalistDetail:salesInvoiceReport.dataCusDetail,
  datalistInvoiceDetail:salesInvoiceReport.dataInvoiceDetail,
  isSuccess: salesInvoiceReport.isSuccess,
  isReset: salesInvoiceReport.isReset,
  isNewRecord: salesInvoiceReport.isNewRecord,
  onSubmit: salesInvoiceReport.onSubmit,
  helperSalesInvoiceReport: salesInvoiceReport.helpersalesInvoiceReport,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setDataCustomer: (data) =>SalesInvoiceReportMiddleware.listCustomer(data),
      setCustomerDetail: (data) =>SalesInvoiceReportMiddleware.listCustomerDetail(data),
      setInvoiceDetail: (data) =>SalesInvoiceReportMiddleware.listInvoiceDetail(data),
    },
    dispatch
  );
};
class SalesInvoiceCustomerReport extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    datalist: PropTypes.any,
    datalistDetail: PropTypes.any,
    datalistInvoiceDetail: PropTypes.any,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      show : 0,
    };
    this.setDataCustomer = this.setDataCustomer.bind(this);
    this.setCustomerDetail = this.setCustomerDetail.bind(this);
    this.setInvoiceDetail = this.setInvoiceDetail.bind(this);

  }

  setDataCustomer() {
    this.props.setDataCustomer();
  }

  setCustomerDetail() {
    this.props.setCustomerDetail();
  }

  setInvoiceDetail(){
    this.props.setInvoiceDetail();
  }


  render() {
    const {show,datalist,datalistDetail,datalistInvoiceDetail,dataCus} = this.props
    return (
      <Fragment>
            <FormSalesInvoiceCustomerReport
             {...this.props}
             dataCus={datalist}
             dataCusDetail={datalistDetail}
             dataInvoiceDetail={datalistInvoiceDetail}
            />
         </Fragment>
     
    );
  }
// }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesInvoiceCustomerReport);
